import EventSettingsForm from './event-settings-form'

export default EventSettingsForm;